/**
 * PageHeader — Sprint 13 S13-28.
 *
 * Header consistente para todas las paginas del sa: eyebrow rojo
 * arriba, titulo h1, descripcion opcional, y slot a la derecha para
 * una accion primaria (ej. boton "+ Nueva X").
 *
 * Reemplaza la duplicacion del mismo bloque en ~10 paginas.
 */
import type { ReactNode } from 'react';

interface PageHeaderProps {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export function PageHeader({
  eyebrow,
  title,
  description,
  action,
}: PageHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        {eyebrow && (
          <div className="text-xs uppercase tracking-wide text-admin-red font-medium">
            {eyebrow}
          </div>
        )}
        <h1 className="text-2xl font-medium text-text-primary mt-1">{title}</h1>
        {description && (
          <p className="text-sm text-text-secondary mt-1 max-w-2xl">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
